import { api } from "../config/axiosConfig";
import { OrderStatus, GetOrdersQuery } from "../types";

export class OrderService {
    
    public static getMany = (query?: GetOrdersQuery) => {
        let requestURL = "/v1/orders";
        return api().get(requestURL, { params: query });
    }
    
    public static updateStatus = (id: number, status: OrderStatus) => {
        let requestURL = `/v1/orders/${id}/status`;
        return api().patch(requestURL, { status });
    }

    public static remove = (id: number) => {
        let requestURL = `/v1/orders/${id}`;
        return (api() as any).delete(requestURL);
    }
}